<template>
  <div id="dataPoster_posterLibrary">
    <div class="inputArea_abs">
      <el-input
        placeholder="请输入您要搜索的内容"
        v-model="curInputVal"
        clearable
        @keyup.enter.native="inputEnterHandler"
      >
        <template slot="prepend">
          <span class="inputIcon el-icon-search"></span>
        </template>
        <template slot="append">搜索</template>
      </el-input>
    </div>
    <div class="leftArea">
      <span
        class="selectArea"
        v-if="groupSelectList && groupSelectList.length > 0"
      >
        <span class="selectArea_title" v-text="'条件筛选'"></span>
        <span class="group_list">
          <span
            class="group_selectList"
            v-for="group in groupSelectList"
            :key="group.groupId"
          >
            <span class="group_titleRow">
              <span class="titleRow_title" v-text="group.groupName"></span>
            </span>
            <span class="group_selectBox">
              <span class="selectBox_item">
                <span
                  v-for="item in group.switchList"
                  :key="item.id"
                  :class="['switch_item checkbox', item.act ? 'act' : '']"
                  @click="clickSwitch(group, item)"
                >
                  <i :class="item.act ? 'el-icon-check' : ''"></i>
                  <span class="switch_item_name" v-text="item.name"></span>
                </span>
              </span>
            </span>
          </span>
        </span>
      </span>
    </div>
    <div class="rightArea">
      <template v-if="posterList && posterList.length > 0">
        <span
          class="posterItem"
          v-for="item in posterList"
          :key="item.posterId"
          @click="goPosterDetail(item)"
        >
          <span class="posterImage">
            <img :src="item.posterPicture" />
          </span>
          <span class="posterInfor">
            <span class="posterInfor_title" v-text="item.posterName"></span>
            <span class="posterInfor_tagList">
              <span
                v-for="(tag, tagIndex) in item.typeFilterNames"
                :key="tagIndex"
                class="tagItem"
                v-text="tag"
              ></span>
            </span>
          </span>
        </span>
      </template>
      <template v-if="posterList && posterList.length == 0">
        <NOT_DATA :className="'relativePtb30'" />
      </template>
    </div>
  </div>
</template>
<script>
import {
  https_dataPoster_posterList,
  https_dataPoster_posterTypes,
} from '@api/platfrom_dataPoster_api.js'
import dataPoster_base_data_mixin from '@mixins/dataPoster_base_data'
import NOT_DATA from '@components/base/NO_DATA.vue'
export default {
  name: 'dataPosterLibrary',
  mixins: [dataPoster_base_data_mixin],
  components: { NOT_DATA },
  data() {
    return {
      posterList: null,
      groupSelectList: null,
      actSwitchArr: [],
      curInputVal: '',
    }
  },
  created() {
    if (this.currGroup) {
      console.debug('init ')
      this.init()
    }
  },
  methods: {
    async init() {
      window.mixtmtBase_eventBus.$emit('loadingEvent', true)
      await this.getPosterTypes()
      await this.getPosterList()
      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
    clickSwitch(group, item) {
      const groupList = JSON.parse(JSON.stringify(this.groupSelectList))
      const actSwitchArr = [] //组装被选中的id
      groupList.forEach((group_org) => {
        if (group_org.switchList && group_org.switchList.length > 0) {
          group_org.switchList.forEach((item_org) => {
            if (
              group_org.groupId === group.groupId &&
              item_org.id === item.id
            ) {
              item_org.act = !item_org.act
            }
            if (item_org.act) {
              actSwitchArr.push(item_org.id)
            }
          })
        }
      })
      this.groupSelectList = groupList
      this.actSwitchArr = actSwitchArr
      setTimeout(() => {
        this.changeConditionEventHandler(this.actSwitchArr, this.curInputVal)
      }, 300)
    },
    inputEnterHandler() {
      console.debug('回车')
      this.changeConditionEventHandler(this.actSwitchArr, this.curInputVal)
    },
    async changeConditionEventHandler(filterIds, name) {
      window.mixtmtBase_eventBus.$emit('loadingEvent', true)
      await this.getPosterList(filterIds, name)
      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
    goPosterDetail(item) {
      if (item && item.posterId) {
        this.openNewWeb(this.$router, `workstationIndex`, { id: item.posterId })
      }
    },
    async getPosterList(filterIds, name) {
      let params = {
        filterIds:
          filterIds && filterIds.length > 0 ? JSON.stringify(filterIds) : '',
        name: name ? name : '',
      }
      await https_dataPoster_posterList(this.axiosBaseUrl, this.$axios, params)
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            console.debug(res.data)
            this.posterList = res.data ? res.data : []
            // this.$imageUrlBlob2Base64(
            //   this.$axios,
            //   'https://images.mixtmt.com/img-cba/cba/team/29115.png',
            //   (e) => {
            //     // const base64Image = reader.result
            //     console.debug('imageUrlBlob2Base64:', e)
            //   }
            // )
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
    async getPosterTypes() {
      await https_dataPoster_posterTypes(this.axiosBaseUrl, this.$axios)
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            console.debug(res.data)
            this.groupSelectList = res.data
              ? res.data.map((group) => {
                  return {
                    groupId: group.typeId,
                    groupName: group.typeName,
                    switchList: group.typeFilters.map((item) => {
                      return {
                        id: item.filterId,
                        name: item.filterName,
                        act: false,
                      }
                    }),
                  }
                })
              : []
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
  },
}
</script>

<style lang="scss" scoped>
#dataPoster_posterLibrary {
  position: relative;
  display: flex;
  display: -webkit-flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  height: auto;
  padding: 6.94vw 0 2.778vw 0;
  /* padding: 2.083vw 0; */
  .inputArea_abs {
    position: absolute;
    left: 0;
    top: 2.083vw;
    z-index: 0;
    width: 40%;
    height: 3.055vw;
    border-radius: 0.5333vw;
    background-color: var(--mixtmt_mainColor);
    .inputIcon {
      font-size: 1.38vw;
    }
  }
  .leftArea {
    display: flex;
    display: -webkit-flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: column;
    width: 18.05vw;
    height: auto;
    padding-right: 1.388vw;
    .selectArea {
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: flex-start;
      flex-direction: column;
      width: 100%;
      height: auto;
      border-radius: 0.533vw;
      .selectArea_title {
        display: flex;
        display: -webkit-flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 3.055vw;
        font-size: 1.11vw;
        color: var(--mixtmt_whiteColor);
        background-color: var(--mixtmt_mainColor);
        font-weight: bold;
        border-radius: 0.533vw 0.533vw 0 0;
      }
      .group_list {
        display: flex;
        display: -webkit-flex;
        justify-content: flex-start;
        align-items: flex-start;
        flex-direction: column;
        width: 100%;
        .group_selectList {
          display: flex;
          display: -webkit-flex;
          justify-content: flex-start;
          align-items: flex-start;
          flex-direction: column;
          width: 100%;
          border: 1px solid var(--mixtmt_greyColor12);
          background-color: var(--mixtmt_greyColor14);
          border-radius: 0 0 0.533vw 0.533vw;
          .group_titleRow {
            display: flex;
            display: -webkit-flex;
            justify-content: flex-start;
            align-items: center;
            width: 100%;
            height: 2.778vw;
            padding: 0 0.694vw;
            background-color: var(--mixtmt_greyColor7);
            .titleRow_title {
              font-size: 0.972vw;
            }
          }
          .group_selectBox {
            display: flex;
            display: -webkit-flex;
            justify-content: flex-start;
            align-items: flex-start;
            flex-direction: column;
            width: 100%;
            height: auto;
            .selectBox_item {
              display: flex;
              display: -webkit-flex;
              justify-content: flex-start;
              align-items: flex-start;
              flex-direction: column;
              width: 100%;
              padding: 1.0416vw 0.694vw;
              .switch_item {
                width: 100%;
                display: flex;
                display: -webkit-flex;
                justify-content: flex-start;
                align-items: center;
                height: 2.778vw;
                .switch_item_name {
                  padding-left: 0.556vw;
                  font-size: 0.972vw;
                }
              }
            }
          }
        }
      }
    }
  }
  .switch_item {
    display: flex;
    display: -webkit-flex;
    justify-content: flex-start;
    align-items: center;
    &.checkbox.act i {
      position: relative;
      border: 1px solid var(--mixtmt_mainColor6);
      background-color: var(--mixtmt_whiteColor);
      color: var(--mixtmt_mainColor6);
      font-weight: bold;
    }
    &.radio.act i {
      position: relative;
      border: 1px solid var(--mixtmt_mainColor6);
      background-color: var(--mixtmt_whiteColor);
      &::before {
        content: '\20';
        position: absolute;
        top: 50%;
        left: 50%;
        z-index: 2;
        transform: translate(-50%, -50%);
        background-color: var(--mixtmt_mainColor6);
        width: 70%;
        height: 70%;
        border-radius: 50%;
        border: 15% solid var(--mixtmt_whiteColor);
      }
    }
    &.checkbox {
      i {
        border-radius: 0.208vw;
      }
    }
    &.radio {
      i {
        border-radius: 50%;
      }
    }
    i {
      width: 1.111vw;
      height: 1.111vw;
      border-radius: 50%;
      border: 1px solid var(--mixtmt_greyColor6);
      background-color: var(--mixtmt_whiteColor);
    }
    .switch_item_name {
      padding-left: 0.69vw;
      font-size: 1.111vw;
      color: var(--mixtmt_greyColor2);
    }
  }
  .rightArea {
    display: flex;
    display: -webkit-flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-wrap: wrap;
    width: calc(100% - 18.05vw);
    padding-bottom: 1.388vw;
    .posterItem {
      position: relative;
      width: 32%;
      padding-top: 27.2%;
      border: 1px solid var(--mixtmt_greyColor12);
      margin: 0 2% 2% 0;
      border-radius: 0.533vw;
      &:nth-child(3n) {
        margin: 0 0 2% 0;
      }
      .posterImage {
        position: absolute;
        left: 0;
        top: 0;
        z-index: 2;
        width: 100%;
        height: 66.178%;
        background-color: var(--mixtmt_greyColor7);
        border-radius: 0.533vw;
        overflow: hidden;
        img {
          display: block;
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
      .posterInfor {
        position: absolute;
        left: 0;
        top: 66.178%;
        z-index: 2;
        width: 100%;
        height: 33.822%;
        padding: 0.972vw 1.0416vw;
        .posterInfor_title {
          width: 100%;
          font-size: 1.1vw;
          line-height: 1.388vw;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
          color: var(--mixtmt_greyColor3);
          font-weight: bold;
        }
        .posterInfor_tagList {
          width: 100%;
          display: flex;
          display: -webkit-flex;
          justify-content: flex-start;
          align-items: center;
          padding-top: 0.533vw;
          height: 2.083vw;
          .tagItem {
            width: auto;
            padding: 0 0.278vw;
            height: 1.388vw;
            font-size: 0.833vw;
            line-height: calc(1.388vw - 1px - 1px);
            background-color: var(--mixtmt_subColor1_1);
            border: 1px solid var(--mixtmt_subColor1_1);
            color: var(--mixtmt_whiteColor);
            border-radius: 0.278vw;
            margin-left: 0.694vw;
            &:first-child {
              margin-left: 0;
            }
          }
        }
      }
    }
  }
}
.mixtmt_pc #dataPoster_posterLibrary {
  .switch_item {
    cursor: pointer;
    &:hover {
      .switch_item_name {
        color: var(--mixtmt_mainColor6);
      }
    }
  }
  .rightArea {
    .posterItem {
      &:hover {
        cursor: pointer;
        border: 1px solid var(--mixtmt_mainColor);
      }
    }
  }
}
</style>
<style lang="scss">
#dataPoster_posterLibrary {
  .inputArea_abs {
    .el-input {
      position: relative;
    }
    .el-input__inner {
      padding: 0 2vw 0 3.055vw;
      height: 3.055vw;
      line-height: calc(3.055vw - 1px - 1px);
      border-radius: 0.53333vw;
      font-size: 1.11vw;
    }
    .el-input-group__prepend {
      position: absolute;
      display: flex;
      display: -webkit-flex;
      justify-content: center;
      align-items: center;
      width: 3.055vw;
      height: 3.055vw;
      padding: 0;
      background-color: transparent;
      color: var(--mixtmt_greyColor2);
      border: 0;
    }
    .el-input-group__append {
      background-color: var(--mixtmt_mainColor);
      color: var(--mixtmt_whiteColor);
      border-left: 0;
      border-color: var(--mixtmt_mainColor);
      padding: 0 1.388vw;
    }
    .el-input__suffix {
      right: 1px;
      .el-input__icon {
        width: 2.68vw;
        line-height: 2.68vw;
        font-size: 1.4vw;
        text-align: center;
      }
    }
  }
}
</style>
